import { render, staticRenderFns } from "./CrisisForm.vue?vue&type=template&id=3c603c06"
import script from "./CrisisForm.vue?vue&type=script&lang=js"
export * from "./CrisisForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports